<template>
  <div>
    <a-modal
      v-model="visible"
      :title="$t('sabbatical.label_title_approval')"
      ok-text="确认"
      cancel-text="取消"
      :centered="true"
      :footer="null"
      :width="684"
      :zIndex="1030"
    >
      <CContainer
        class="approval-sabbatical"
        v-if="employeeSabbaticalRequest.id"
      >
        <div class="create_form">
          <CRow>
            <CCol md="6"  class="form-field">
              <label>
                {{ $t("commons.label_employee_send") }}
              </label>
              <CInput
                :disabled="true"
                :value="
                  employeeSabbaticalRequest.employee
                    ? employeeSabbaticalRequest.employee.name
                    : ''
                "
              />
            </CCol>
            <CCol md="6" class="form-field">
              <label>
                {{ $t("employee.label_employee_foot") }}
              </label>
              <CInput
                :disabled="true"
                v-model="employeeSabbaticalRequest.foot"
              />
            </CCol>
            <CCol md="6" class="form-field">
              <label>
                {{ $t("employee.label_employee_division") }}
              </label>
              <CInput
                :disabled="true"
                v-model="employeeSabbaticalRequest.division"
              />
            </CCol>
            <CCol md="6" class="form-field">
              <label>
                {{ $t("commons.label_created_at") }}
              </label>
              <CInput
                :disabled="true"
                v-model="employeeSabbaticalRequest.created_at"
              />
            </CCol>
            <CCol md="6" class="form-field">
              <label>
                {{ $t("employee.label_employee_date_start") }}
              </label>
              <CInput
                :disabled="true"
                v-model="employeeSabbaticalRequest.start_date"
              />
            </CCol>
            <CCol md="6" class="form-field">
              <label>
                {{ $t("overtime.end_time") }}
              </label>
              <CInput
                :disabled="true"
                v-model="employeeSabbaticalRequest.end_date"
              />
            </CCol>
            <CCol md="6" class="form-field" v-if = "employeeSabbaticalRequest.reason_type == 4">
              <label>
                Thời gian nghỉ (phút)
              </label>
              <CInput
                :disabled="true"
                :value="Math.round(employeeSabbaticalRequest.number_days_off*480)"
              />
            </CCol>

            <CCol md="6" class="form-field" v-else>
              <label>
                Thời gian nghỉ (ngày)
              </label>
              <CInput
                :disabled="true"
                v-model="employeeSabbaticalRequest.number_days_off"
              />
            </CCol>
            <CCol md="6" class="form-field">
              <label>
                {{ $t("commons.status") }}
              </label>
              <CInput
                :disabled="true"
                :value="
                  $t(
                    'overtime.employee_approval_' +
                      employeeSabbaticalRequest.status
                  )
                "
              />
            </CCol>
            <CCol md="6" class="form-field">
              <label>
                {{ $t("commons.label_reason") }}
              </label>
              <CInput
                :disabled="true"
                :value="
                  employeeSabbaticalRequest.sabbatical_leave_reason
                    ? employeeSabbaticalRequest.sabbatical_leave_reason.reason
                    : ''
                "
              />
            </CCol>
            <CCol md="6" class="form-field">
              <label>
                {{ $t("sabbatical.type_reason") }}
              </label>
              <CInput
                :disabled="true"
                :value="
                  $t(
                    'sabbatical.type_reason_' +
                      employeeSabbaticalRequest.reason_type
                  )
                "
              />
            </CCol>
            <CCol md="12" class="form-field">
              <label>
                {{ $t("sabbatical.note") }}
              </label>
              <b-form-textarea
                id="textarea"
                rows="4"
                max-rows="6"
                :disabled="true"
                v-model="employeeSabbaticalRequest.note"
              ></b-form-textarea>
            </CCol>
          </CRow>
          <!-- Sabbatical approval list-->
          <CRow class="mt-4">
            <CCol md="12" sm="12" class="employees-form approval-ot">
              <div class="text-label">
                <div class="text-center">
                  <h4 class="title-header">
                    {{ $t("overtime.information_approval_ot") }}
                  </h4>
                </div>
              </div>
              <div class="text-label-content">
                <div class="table-responsive table-employee-note">
                  <table class="table">
                    <thead>
                      <tr>
                        <th class="index">#</th>
                        <th class="text-center create-by">
                          {{ $t("overtime.employee_approval") }}
                        </th>
                        <th class="text-center create-at">
                          {{ $t("overtime.employee_approval_status") }}
                        </th>
                        <th class="text-center">
                          {{ $t("overtime.employee_approval_note") }}
                        </th>
                        <th class="text-center">
                          {{ $t("overtime.employee_approval_time") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <template
                        v-if="
                          employeeSabbaticalRequest &&
                          employeeSabbaticalRequest.sabbatical_leave_approves &&
                          employeeSabbaticalRequest
                            .sabbatical_leave_approves[0] &&
                          employeeSabbaticalRequest
                            .sabbatical_leave_approves[1] &&
                          employeeSabbaticalRequest.sabbatical_leave_approves[0]
                            .employee_id ===
                            employeeSabbaticalRequest
                              .sabbatical_leave_approves[1].employee_id
                        "
                      >
                        <tr>
                          <th scope="row index">1</th>
                          <td>
                            {{
                              employeeSabbaticalRequest
                                .sabbatical_leave_approves[0].employees[0].name
                            }}
                          </td>
                          <td>
                            {{
                              $t(
                                `overtime.employee_approval_${employeeSabbaticalRequest.sabbatical_leave_approves[0].status}`
                              )
                            }}
                          </td>
                          <td class="comment">
                            {{
                              employeeSabbaticalRequest
                                .sabbatical_leave_approves[0].comment
                            }}
                          </td>
                          <td>
                            {{
                              employeeSabbaticalRequest
                                .sabbatical_leave_approves[0].updated_at
                                | formatDateTime
                            }}
                          </td>
                        </tr>
                      </template>
                      <template v-else>
                        <tr
                          v-for="(
                            item, index
                          ) in employeeSabbaticalRequest.sabbatical_leave_approves"
                          :key="index"
                        >
                          <th scope="row index">{{ index + 1 }}</th>
                          <td>{{ item.employees[0].name }}</td>
                          <td>
                            {{
                              $t(`overtime.employee_approval_${item.status}`)
                            }}
                          </td>
                          <td class="comment">{{ item.comment }}</td>
                          <td>{{ item.updated_at | formatDateTime }}</td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </CCol>
          </CRow>
          <div
            v-if="
              employeeSabbaticalRequest &&
              myApproveInfo &&
              employeeSabbaticalRequest.status === 1 &&
              myApproveInfo.status === 1
            "
          >
            <ValidationObserver ref="form">
              <CRow>
                <CCol md="12" class="form-field">
                  <label>
                    {{ $t("commons.note") }}
                     <!-- <span class="require">*</span> -->
                  </label>
                  <ValidationProvider
                    rules="max:512"
                    v-slot="{ errors }"
                    name="overtime.note"
                  >
                    <b-form-textarea
                      rows="3"
                      max-rows="6"
                      v-model="forms.comment"
                    />
                    <span v-if="!error" class="error image required">
                      {{ errorMessage }}
                    </span>
                    <span class="required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </CCol>
                <CCol
                  md="12"
                  class="button-group mt-4 text-center"
                  v-if="employeeSabbaticalRequest.editable"
                >
                  <CButton
                    type="button"
                    class="save-info"
                    @click="showPopupApprove()"
                  >
                    {{ $t("commons.approve") }}
                  </CButton>
                  <CButton
                    class="cancel-employee"
                    type="button"
                    @click="showPopupCancel()"
                  >
                  <span v-if = "pmWaitingForApproval">
                          {{ $t("commons.admin_unapprove") }}
                  </span>
                  <span v-else>
                    {{ $t("commons.cancel_approve") }}
                  </span>
                  </CButton>
                </CCol>
              </CRow>
            </ValidationObserver>
          </div>
        </div>
      </CContainer>
    </a-modal>
    <CusModal
      @handleCancel="hideApprovalConfirm"
      @handleOk="approveRequest"
      :title="popupConfirmTitle"
      :isShow="isShowApprovalConfirm"
    >
      <div class="modal-content">
        <div class="warning-title">
          <img src="/img/icons/warning-icon.svg" alt="" />
          {{ $t("popup.commons.label_confirm_title") }}
        </div>
      </div>
    </CusModal>
  </div>
</template>

<script>
import CusModal from "@/components/commons/CusModal.vue";
import { mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
// import moment from "moment";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    CusModal,
  },

  data() {
    return {
      id: null,
      visible: false,
      popupConfirmTitle: '',
      forms: {
        status: 0,
        comment: "",
      },
      error: true,
      errorMessage:"",
      myApproveInfo: {},
      listEmployeeIdApproval: [],
      isShowApprovalConfirm: false,
    };
  },

  computed: {
    ...mapGetters({
      employeeSabbaticalRequest:
        "sabbatical-leave-request/employeeSabbaticalRequest",
      flagNotification: "commons/flagNotification",
    }),
    // checkValidDate() {
    //   let currentSubWeek = moment().subtract(8, "d").format("YYYY-MM-DD");
    //   return moment(currentSubWeek).isBefore(
    //     moment(
    //       this.employeeSabbaticalRequest.requestInfo.date,
    //       "DD/MM/YYYY"
    //     ).format("YYYY-MM-DD"),
    //     "day"
    //   );
    // },
    pmWaitingForApproval()
    {
      return  this.employeeSabbaticalRequest.sabbatical_leave_approves[0] && 
      this.employeeSabbaticalRequest.sabbatical_leave_approves[0].level == 1 && 
      this.employeeSabbaticalRequest.sabbatical_leave_approves[0].status == 1 && 
      this.employeeSabbaticalRequest.sabbatical_leave_approves[1]; 
    }
  },

  methods: {
    // ...mapMutations("commons", ["setNotificationFlag"]),

    async show(id) {
      if (id) {
        await this.getInfoApprovalById(id);
        this.id = id;
        this.forms.comment = "";
        this.forms.status = 0;
        this.listEmployeeIdApproval = [];
        this.visible = true;

        // const account = this.$store.getters["auth/account"];
        // if (this.employeeSabbaticalRequest.approveInfo) {
        //   this.myApproveInfo = this.employeeSabbaticalRequest.approveInfo.filter(
        //     (f) => f.approve_employee_id === account.id
        //   )[0];
        //   let check = 0;
        //   for (let key in this.employeeSabbaticalRequest.approveInfo) {
        //     if (
        //       account.id ===
        //       this.employeeSabbaticalRequest.approveInfo[key].approve_employee_id
        //     ) {
        //       check++;
        //       if (check === 2) {
        //         break;
        //       }
        //     }
        //     this.listEmployeeIdApproval.push(
        //       this.employeeSabbaticalRequest.approveInfo[key]
        //     );
        //   }
        // }
        // this.setNotificationFlag(false);
      }
    },
    async getInfoApprovalById(id) {
      this.$root.$loading.start();
      await this.$store.dispatch(
        "sabbatical-leave-request/showEmployeeSabbaticalRequest",
        id
      );
      const account = this.$store.getters["auth/account"];
      if (this.employeeSabbaticalRequest.sabbatical_leave_approves) {
        this.myApproveInfo =
          this.employeeSabbaticalRequest.sabbatical_leave_approves.filter(
            (f) => f.employee_id === account.id
          )[0];
      }
      this.$root.$loading.finish();
    },

    async approveRequest() {
      if (this.forms.status === 3) {
        if (this.forms.comment === "") {
          this.error = false;
          this.errorMessage = this.$t(
            "error.validation.approve_person_comment.required"
          );
          return false;
        }
      }
      this.$root.$loading.start();
      await this.$store
        .dispatch("sabbatical-leave-request/approvalSabbatical", {
          data: this.forms,
          id: this.id,
        })
        .then(() => {
          let message = this.$t("overtime.message_approval_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$emit("fetchData");
          this.hideApprovalConfirm();
          this.hideModal();
          this.$store.dispatch("commons/getCountRequest");
          this.$root.$loading.finish();
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    },

    hideModal() {
      this.visible = false;
    },
    showApprovalConfirm(aprove) {
      if (aprove) {
        this.forms.status = 2;
        this.popupConfirmTitle = this.$t('popup.sabbatical.label_popup_confirm_approve_sabbatical_title')
      } else {
        this.forms.status = 3;
        this.popupConfirmTitle = this.$t('popup.sabbatical.label_popup_confirm_reject_sabbatical_title')
      }

      this.isShowApprovalConfirm = true;
    },
    hideApprovalConfirm() {
      this.isShowApprovalConfirm = false;
      this.errorMessage = "";
    },
    showPopupCancel(){
      if ((this.employeeSabbaticalRequest.sabbatical_leave_approves[0] && 
        this.employeeSabbaticalRequest.sabbatical_leave_approves[0].level == 1 && 
        this.employeeSabbaticalRequest.sabbatical_leave_approves[0].status != 1 ) || !this.employeeSabbaticalRequest.sabbatical_leave_approves[1]){
          this.forms.status = 3;
          this.popupConfirmTitle = this.$t('popup.sabbatical.label_popup_confirm_reject_sabbatical_title')
        }
        else
        {
          this.forms.status = 5;
          this.popupConfirmTitle = "Xác nhận đề xuất đơn nghỉ phép"
        }
        this.isShowApprovalConfirm = true;
    },
    showPopupApprove(){
      this.forms.status = 2;
      this.popupConfirmTitle = this.$t('popup.sabbatical.label_popup_confirm_approve_sabbatical_title')
      this.isShowApprovalConfirm = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.approval-sabbatical {
  max-height: 700px;
  overflow-y: scroll;

  .create_form {
    .textarea-form {
      overflow-y: initial !important;
    }

    .required {
      color: #f03d3e;
    }
    .button-group {
      display: flex;
      gap: 20px;
      margin-bottom:10px;
      justify-content: center;
      .save-info {
         max-width: 210px;
        width: 50%;
        background: #3d4cdc;
        border-radius: 10px;
        font-weight: 700;
        font-size: 14px;
        color: #ffffff;
      }
      .cancel-employee {
         max-width: 210px;
        width: 50%;
        background: #ececec;
        border-radius: 10px;
        color: #6f6f6f;
        font-weight: 700;
        font-size: 14px;
      }
    }
    .btn-back {
      max-width: 210px;
      width: 100%;
      background: #ececec;
      border-radius: 10px;
      color: #6f6f6f;
      font-weight: 700;
      font-size: 14px;
    }
  }
}
.modal-content {
  border: none;
  .warning-title {
    display: flex;
    justify-content: center;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: #303c54;
    img {
      margin-right: 10px;
    }
  }
}
</style>

<style lang="scss">
.ant-modal-close:focus {
  outline: none;
}

.ant-modal-close-x {
  display: flex;
  width: 100%;
  align-items: center;
  margin-right: 24px;
}
</style>
